import AlarmFilledIcon from './AlarmFilledIcon';

export default AlarmFilledIcon;
